<template>
<div class="rating mt-2">
    <span 
        v-for="star in 5" 
        :key="star" 
        class="star relative ml-2 mr-2 cursor-pointer" 
        :class="{ filled: star <= Math.ceil(rating) }" 
        @click="setRating(rating)"
        @mousemove="hoverRating($event, star)"
        @mouseleave="resetHover"
    >
        <i 
            class="pi !text-3xl" 
            :class="star > rating && star != Math.ceil(rating) ? 'pi-star' : (star == Math.ceil(rating) && star > rating ? 'pi-star-half-fill' : 'pi-star-fill')"
        ></i>
        <i class="pi pi-star absolute top-[-19px] left-0 !text-3xl"></i>
    </span>
</div>


</template>
<script>
export default {
    name: 'Rating',
    props: {
        modelValue: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            startValue: null,
            rating: this.modelValue,
            tempRating: null
        };
    },
    mounted() {
        this.startValue = this.rating;
    },
    methods: {
        setRating(star) {
            this.rating = star;
            this.startValue = this.rating;
            this.$emit('update:modelValue', this.rating);
            this.$emit('change',this.rating)
        },
        hoverRating(event, star) {
            const rect = event.target.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const width = rect.width;
            const isHalf = mouseX < width / 2;
            this.tempRating = this.rating;
            this.rating = star - (isHalf ? 0.5 : 0);

        },
        resetHover() {
            this.rating = this.startValue;
            if (this.tempRating !== null) {
                //this.rating = this.tempRating;
                this.tempRating = null;
            }
        }
    },
    watch: {
        modelValue(newValue) {
            this.rating = newValue;
        }
    }
};
</script>